export const en = {
  bubbleExpiration: {
    expiredTitle: "Free Premium has Expired",
    expiredSubtitle: "Upgrade to Premium for the best PhotoVault Experience",
    expiredSubtitlePremium:
      "Upgrade to Premium for a great PhotoVault Experience",
    expiredSubtitleUltimate:
      "Upgrade to Ultimate for the best PhotoVault Experience",
    trashRecovery: "Trash recovery",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "No ads",
    everyPremiumFeature: "Get every\nPremium feature",
    everyUltimateFeature: "Get every\nUltimate feature",
    unlockUltimateTools: "Unlock every privacy tool in the app.",
    cloudVaultUltimate: "Cloud Vault - 1,000 GB",
    organizationPlus: "Organization+",
    organizationPlusDesc: "Create Sub Albums, Find Duplicates and more.",
    monthly: "Monthly",
    yearly: "Yearly",
    perMonth: "per month",
    perYear: "per year",
    justOnce: "just once",
    lifetime: "Lifetime",
    threeMonths: "3 Months",
    lifetimeTitle: "Unlock Lifetime Access",
    lifetimeDescription:
      "The lifetime plan will be available soon. Stay tuned for updates!",
    lifetimeFeature1: "One-time payment",
    lifetimeFeature2: "Lifetime access to all Premium features",
    lifetimeFeature3: "Best value for long-term users",
    lifetimeCta: "Purchase Lifetime",
    lifetimeSheetDisclaimer: "Cloud backup (50GB) is included for 5 years.",
    lifetimeSheetDisclaimerDetailed:
      "5 years of Cloud Vault backup (50 GB) is included with your Lifetime plan. After, you'll be eligible for a discounted Cloud Vault subscription only available to Lifetime members. All Premium features will always remain available at no additional cost.",
    lifetimeDisclaimerCloudStorage:
      "5 years of Cloud Vault backup (50 GB) is included with your Lifetime plan.",
    lifetimeDisclaimerAfterPeriod:
      "After 5 years, you'll be eligible for a discounted Cloud Vault subscription only available to Lifetime members.",
    lifetimeDisclaimerPremiumFeatures:
      "All Premium features will always remain available at no additional cost.",
    selectPlan: "Select a plan to continue",
    unlockPrivacyTools: "Unlock excellent privacy tools.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "Secure backups that stay encrypted.",
    freeUpSpace: "Free up space on your phone.",
    recoverDeleted: "Recover deleted items from trash.",
    fullExperience: "The full experience with no interruptions.",
    restorePurchases: "Restore Purchases",
    basicTitle: "Private Photo Vault Basic",
    free: "FREE",
    basicDescription:
      "Basic is the free version of PhotoVault. It still protects your important photos behind a PIN screen and gives you good privacy features.",
    switchToBasic: "Switch to Basic",
    termsOfService: "Terms of Service",
    privacy: "Privacy",
    switchToPremium: "Switch to Premium",
    switchToUltimate: "Switch to Ultimate",
  },
  title: "Unlimited Access\nto All Features",
  freeTrial: "Free Trial",
  startPlan: "Start Plan",
  pricePerMonth: (price: any) => `${price}/month`,
  pricePerYear: (price: any) => `${price} per year`,
  discount: (discount: number) => `${discount}% OFF`,
  new: "new",
  trashRecovery: "Trash Recovery",
  adFree: "Ad Free Experience",
  breakIn: "Break-In Report: Photo & GPS",
  wireless: "Wireless Photo Transfer",
  decoy: "Decoy Passcode",
  pattern: "Pattern Lock",
  appDisguise: "App Disguise",
  comingSoon: "coming soon",
  subscriptionTerms: "Subscription Terms:",
  terms:
    "Payment will be charged to iTunes Account at confirmation of purchase. The subscription automatically renews unless auto-renew is turned off at least 24-hours before the end of the current period. Account will be charged for renewal within 24-hours prior to the end of the current period. You may manage your subscription and turn off auto-renewal by going to your Account Settings after purchase.",
  privacy: "Privacy",
  alreadyPurchased: "Already Purchased?",
  termsButton: "Terms",
  monthly: "MONTHLY",
  yearly: "YEARLY",
  popular: "POPULAR",
  save: (discount: number) => `SAVE ${discount}%`,
  anniversaryTitle: (discount: number) =>
    `Anniversary Deal - SAVE ${discount}%`,
  blackFridayTitle: (discount: number) => `Black Friday - SAVE ${discount}%`,
  year: "year",
  years: "years",
  hour: "hour",
  hours: "hours",
  minute: "minute",
  minutes: "minutes",
  second: "second",
  seconds: "seconds",
  promoSubtitle: (hours: number) =>
    `Hurry up, this sale will only last for ${hours} hours`,
  offerExpires: "Until offer expires",
  unlockDeal: "Unlock Deal",
  blackFridayPaywallTitle: "Black Friday Deal",
  anniversaryPaywallTitle: "Your anniversary offer 🎉",
  blackFridayPaywallSubtitle:
    "Don't miss out on this one-time offer for Black Friday! Get huge savings on our annual subscription.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `Congratulations on ${years} years with us! To celebrate, here's a ${discount}% discount on Premium. Thank you for your loyalty!`,
  blackFridayAnnualTitle: "Your black friday offer 🎉",
  anniversaryAnnualTitle: "Your anniversary offer 🎉",
  oneYear: "1 year",
  oneMonth: "1 month",
  lockedIn: "This yearly price will be locked in FOREVER",
  subtitleFixed: "Hurry up, this sale will end soon!",
  importTitle: "Add photos<br />to your secure vault",
  importSubtitle: "It's 100% private!",
  importInfo:
    "Our zero-knowledge encryption ensures that your data remains private, even from us.",
  importCTA: "Select Photos",
  totalMonthsPrice: (price: string) => `12 mo • ${price}`,
  monthlyPrice: (price: string) => `${price} / mo`,
  returnOffer: {
    monthly: (price: string) => `as low as ${price}/month`,
    title: "Your Exclusive<br />Return Offer",
    subTitle:
      "Reactivate Your Membership Today at a Special Rate!<br />Available for a Limited Time Only",
    discountTitle: "Special Discount",
    cta: "Reactivate Now",
    discountSubTitle: "Limited Time Offer",
  },
  oneTimeOffer: {
    title: "Your<br />one-time offer",
    subTitle: "Once you close your one-time offer, it's gone!",
    claim: "Claim your one-time offer",
  },
  off: "OFF",
  special: "SPECIAL",
  yearlyPlan: "Yearly Plan",
  monthlyPlan: "Monthly Plan",
  subscribe: "Subscribe",
  cancelAnytime: "Cancel anytime",
  freeTrialPaywall: {
    title: "How your free trial works",
    firstStep: {
      title: "Now",
      subtitle:
        "Unlock unlimited access to Private Photo Vault and never worry about anyone seeing your private photos again",
    },
    secondStep: {
      title: "Today: Start your free trial",
      subtitle: "Unlock full access to PhotoVault. You won’t be charged today.",
    },
    thirdStep: {
      title: "In 7 Days",
      subtitle:
        "You’ll be charged on this day. Cancel anytime before, hassle free.",
    },
    whatsIncluded: "See What's Included",
    viewAllPlans: "View all plans",
    startTrial: "Start Free Trial",
    footerTitle: (yearlyPrice: string, monthlyPrice: string) =>
      `7 days FREE and then ${yearlyPrice}/year\n(${monthlyPrice} per month)`,
    footerDisclaimer:
      "Cancel anytime before your trial ends. You will only be charged after 7 days",
    featureList: {
      title: "What is Private Photo Vault?",
      infoTitle: "100% Private and Secure",
      infoSubtitle: "Protect your data and prevent unauthorized access",
      subTitle: "Go Premium and get access to:",
    },
    comparePlans: {
      monthly: "Monthly",
      yearly: "Yearly",
      ultimateYearly: "Ultimate Yearly",
      threeMonths: "3 Months",
      freeFor: (days: number) => `Free for ${days} days`,
      monthlyPrice: (price: string) => `only ${price}/month`,
      dailyPrice: (price: string) => `only ${price}/day`,
      cta: "Continue",
    },
  },
  comparePlans: {
    title: "Compare Plans",
    compare: "Compare",
    freeTitle: "Free",
    basicTitle: "Basic",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Unlock Premium",
    unlockUltimate: "Unlock Ultimate",
    choose: "CHOOSE A PLAN",
  },
  features: {
    organizationPlus: "Organization+",
    securityPlus: "Security+",
    duplicateDetection: "Duplicate Detection",
    faceDownLock: "Face Down Lock",
    customIcons: "Custom Icons",
    encryptedStorage: "Encrypted Photo Storage",
    unlimitedAlbums: "Unlimited Albums",
    browser: "Secure Web Browser",
    camera: "Private Camera",
    subalbums: {
      title: "Sub Albums",
      description:
        "Create multiple levels of sub-albums to organize your content efficiently.",
    },
    filteringAndSearching: {
      title: "Filtering and Searching",
      description:
        "Search through your albums and apply filters to find specific content types.",
    },
    alphanumericPasscode: {
      title: "Alphanumeric Passcode",
      description:
        "Enhance your app's security by using an alphanumeric password.",
    },
    dualLock: {
      title: "Require Passcode + Face ID",
      description:
        "For extra security, require both your Passcode and Face ID every time you enter the app.",
    },
    locationBasedLock: {
      title: "Location Based Lock",
      description: "Only allow unlocking the app in approved GPS locations",
    },
  },
  gotIt: "Got It!",
  promo: {
    premiumSave: (percent: string) => `SAVE ${percent}% ON PREMIUM`,
    monthly: (price: string) => `Only ${price}/month`,
    yearly: (price: string) => `${price}/year`,
    limited: "LIMITED TIME REMAINING",
    claimOffer: "Claim Offer",
    seconds: (count: number) => (count == 1 ? "SECOND" : "SECONDS") as string,
    minutes: (count: number) => (count == 1 ? "MINUTE" : "MINUTES") as string,
    oneTimeOffer: "ONE TIME OFFER",
    normalFee: "normal fee",
    backTo: "back to",
    yearlyShort: (price: string) => `${price}/yr`,
  },
  premiumToUltimateBlackFriday: {
    title: "BLACK FRIDAY SALE",
    subTitle: "GO ULTIMATE",
    cloud: {
      title: "1,000GB Cloud Storage",
      description: "Secure cloud storage for 500,000+ photos",
    },
    duplicateDetection: {
      description: "Locate and remove duplicate images",
    },
    organizationPlus: {
      description: "Create Sub Albums, filter, and search your photos",
    },
    securityPlus: {
      description:
        "Enhanced security with Alphanumerical Passcode, Location Based Lock and more ",
    },
    timeRemaining: "TIME REMAINING",
    saleBanner: "LIMITED TIME MEGA SALE",
    saleTitle: "Black Friday Sale 🎉",
    monthPrefix: "12 mo • ",
    perMonthPrice(price: string) {
      return `${price} / mo`
    },
    monthly: "Monthly",
    ultimateLaunch: {
      title: "UPGRADE TO ULTIMATE",
      saleTitle: "Ultimate Launch Sale 🚀",
      bannerTitle: (discount: number) =>
        `Upgrade to Ultimate - SAVE ${discount}%`,
    },
  },
  beforeYouGo: {
    title: "Hold On - Before You Leave",
    subtitle: "Keep your photos secure and private",
    subtitle2: "Get 7 days of Premium completely free.",
    cta: "Start Your Free Trial",
    cancelTitle:
      "Cancel anytime before your trial ends, and you won’t be charged until the full 7 days are up.",
    skipCta: "No thanks",
  },
  enableTrial: "Not sure yet? Enable free trial",
  startTrial: "Start Free Trial",
  trialActivated: (days: number) => `${days} DAY TRIAL ACTIVATED`,
  specialOffer: {
    enabledTitle: "Special offer enabled",
    trialTitle: "Claim your bonus 7 day trial",
    expirationTitle: "Your Subscription Is Expiring Soon!",
    expirationSubtitle: "Renew your subscription at a special rate!",
    priceBoxExpiration: {
      title: "Special Renewal Offer",
      offerName: "Yearly Plan",
      ctaTitle: "Claim Special Offer",
    },
    priceBoxTrial: {
      title: "Exclusive extra 7-day free trial offer",
      offerName: "Extra 7-day trial",
      ctaTitle: "Claim bonus free trial",
    },
  },
  premiumToUltimate: {
    titleLine1: "ULTIMATE UPGRADE",
    titleLine2: "ONE TIME OFFER",
    megaSaleBanner: "LIMITED TIME MEGA SALE",
    upgradeTitle: "Ultimate Upgrade Sale",
    yearlySubtitlePrefix: "12 mo •",
    monthlyPriceSuffix: "/ month",
  },
  monthlyToYearly: {
    titleLine1: "Yearly Upgrade",
    titleLine2: "One Time Offer",
    subtitleWarning: "Once you close your one-time offer, it's gone!",
    specialLabel: "SPECIAL",
    offerTitle: "Claim your one-time offer",
    offerName: "Yearly Plan",
    subscribeButton: "Upgrade",
    cancelAnytime: "Cancel anytime",
    yearlySubtitlePrefix: "12 mo •",
    monthlyPriceSuffix: "/ month",
  },
  expiration: {
    warmup: {
      close: "CLOSE",
      subtitle:
        "Keep your photos SAFE and RECOVERABLE if your phone gets lost or stolen",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "Encrypted backup for your files",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1,000 GB Cloud Vault storage",
        },
        reviews: {
          title: "500,000+ 5 Star Reviews",
          subtitle: "Trusted by millions",
        },
        noAds: {
          title: "No Ads",
          subtitle: "Ad free experience",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "Sub albums, better filtering, and more",
        },
      },
      footer: "& every feature!",
      switchToPremium: "Switch to Premium",
      switchToUltimate: "Switch to Ultimate",
      titlePremium: "Your Premium has Expired!",
      titleUltimate: "Your Ultimate has Expired!",
      popular: "POPULAR",
      perMonth: "per month",
      perYear: "per year",
    },
    titlePremium: "Premium has Expired",
    titleUltimate: "Ultimate has Expired",
    subtitlePremium:
      "Renew Premium to keep all your features, or switch to Basic for free",
    subtitleUltimate:
      "Renew Ultimate to keep all your features, or switch to Basic for free",
    basicButton: "Switch to Basic",
    basicTitle: "What is basic?",
    basicDescription:
      "Basic is the free version of the app. It still allows you to protect your photos and videos behind a PIN. However you will lose access to Encrypted Cloud Vault Backup and all other Premium features",
  },
  animated: {
    title: "Choose Your Plan",
    yearlyPrice: (price: string) => `Just ${price} per year`,
    subtitle: "Auto- renewable. Cancel anytime",
    cta: "Continue",
    trial: "Free Trial Enabled",
    breakinShort: "Break-In Report",
    unlimitedPhotos: "Unlimited Photos",
  },
  choosePlanTitle: "Choose Your Plan",
  multistep: {
    lockTitle: "Lock Private Photos",
    subtitle: {
      line1: "We offer",
      line2: "7 days free",
      line3: "so everyone can protect their pictures",
    },
    subtitleReminder: {
      line1: "You’ll get a reminder ",
      line2: "2 days ",
      line3: "before your trial ends.",
    },
    noPaymentNow: "No Payment Now",
    startFreeWeek: "Start Your FREE Week",
    payTitle: "7 Days for Free",
    afterPrice: (price: string) => `then ${price} / month`,
    afterBilling: (price: string) =>
      `(billed as ${price} annually after the trial)`,
    footerTitle: (price: string) => `Free for 7 days. Then, ${price}/year`,
    footerMonthlyTitle: (price: string) =>
      `You will be charged ${price} immediately.`,
    headerTitle: "7-Day Free Trial",
    anual: "Annual",
    monthly: "Monthly",
    noTrial: "No Free Trial",
    yearlyPrice: (price: string) => `${price} / Year`,
  },
  oneTimeOfferTitle: "ONE-TIME OFFER",
  unlockPremiumFor: "Unlock Annual Premium for",
  oneTimeOfferSubtitle: "This is a one-time offer",
  lowestPrice: "LOWEST PRICE EVER",
  summerSale: {
    title: "SUMMER SALE",
    tagline: "The sun sees all... except what's in your vault!",
    timeRemaining: "Deal Expires Soon",
    limitedTimeOffer: "Limited Time Offer",
    savePercent: (percent: number) => `Save ${percent}%`,
    bannerSubtitle: (price: string) => `Get Premium for ${price}`,
    bannerSubtitleUltimate: (price: string) => `Get Ultimate for ${price}`,
    getPremium: "Get Premium Privacy",
    getUltimate: "Get Ultimate Privacy",
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
    features: {
      premiumFeature: {
        title: "Get Every Premium Feature",
        description: "Premium tools that protect your privacy.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "Secure backups that stay encrypted.",
      },
      noAds: {
        title: "No Ads",
        description: "The full experience with no interruptions.",
      },
      faceDownLock: {
        title: "Face Down Lock",
        description: "Instantly App lock by flipping your phone.",
      },
      breakInReports: {
        title: "Break In Reports",
        description: "Alerts if someone tries to access your vault.",
      },
    },
    pricing: {
      summerSale: "Summer Sale",
      monthly: "Monthly",
      perMonth: (price: string) => `${price} / mo`,
      twelveMonths: "12 mo",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  halloweenSale: {
    title: "HALLOWEEN SALE",
    tagline: "The night hides many things…\nespecially yours!",
    buttonTitle: "Halloween Sale",
  },
  emailPromo: {
    title: "Exclusive Premium Offer",
    upgradeButton: "Upgrade to Premium",
    yearlyTitle: "Premium Yearly",
    decoyDescription: "Create a fake vault that opens with a decoy password",
  },
  onboardingUltimateAlternate: {
    title: "Start Your Free Trial",
    premiumDescription: "Unlock excellent privacy tools.",
    ultimateDescription: "The best Photo Vault experience.",
    includesPremium: "Includes Premium",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7 days free, then ${yearlyPrice} (${monthlyPrice}/mo)`,
    timeline: {
      today: "Today:",
      todayDescription: "start your free trial",
      day5: "Day 5:",
      day5Description: "get reminder",
      day7: "Day 7:",
      day7Description: (yearlyPrice: string) =>
        `you will be charged ${yearlyPrice}`,
    },
    comparisonTable: {
      header: "What you get",
    },
    didYouKnow: {
      label: "Did you know?",
      statNumber: "3X",
      statDescription: "Subscribers get 3 times more peace of mind",
    },
    pricing: {
      yearlyPlanTitle: "Yearly Plan",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/year`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/month`,
      monthlyTitle: "Monthly",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/month`,
      popularBadge: "POPULAR",
    },
    ctaButton: "Start free trial",
  },
}

export type StringsType = typeof en
